import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Typography, styled } from '@mui/material';
import ArticlesData from '../../../assets/data/articlesData';

import img1 from '../../../assets/images/articles/A1.jpeg';
import img2 from '../../../assets/images/articles/A2.jpeg';
import img3 from '../../../assets/images/articles/A3.jpeg';
import img4 from '../../../assets/images/articles/A4.jpeg';

const articlesData = [
  { img: img1, text: 'Accelerating Innovation in the EV Sector with Agile Market Research', imgTop: true },
  { img: img2, text: 'How Agile Research Is Revolutionizing Product Development in Clean Tech', imgTop: false },
  { img: img3, text: 'The Role of Market Research in Shaping the Future of AI-Driven Healthcare', imgTop: true },
  { img: img4, text: 'Decoding Gen Z: How Agile Research Uncovers Emerging Consumer Preferences', imgTop: false },
];

const ArticlesBox = styled(Box)(({ theme }) => ({
  width: '95%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  // flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: '2rem',
  [theme.breakpoints.down('xl')]: {
    width: '95%',
  },
  [theme.breakpoints.down('mdlg')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

const ArticleCard = ({ Image, description, imgTop }) => (
  <Box
    sx={{
      width: { xs: '90%', mdlg: '23%' },
      display: 'flex',
      flexDirection: { xs: 'row', mdlg: 'column' },
      padding: '1rem',
      gap: { xs: '2rem', mdlg: '3rem' },
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    {imgTop && <ImageContainer src={Image} />}
    <Box
      sx={{
        width: { xs: '50%', mdlg: '100%' },
        height: { xs: '100%', mdlg: '35%' },
        display: 'flex',
        justifyContent: 'center',
        alignItems: imgTop ? 'end' : 'start',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' },
          fontWeight: 600,
          color: '#242424',
          textAlign: 'center',
        }}
      >
        {description}
      </Typography>
    </Box>
    {!imgTop && <ImageContainer src={Image} />}
  </Box>
);

const ImageContainer = ({ src }) => (
  <Box
    sx={{
      width: '100%',
      height: { xs: '30vh', sm: '35vh', mdlg: '41vh' },
      backgroundColor: '#242424',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Box component="img" src={src} alt="Article" sx={{ width: '85%', height: '85%' }} />
  </Box>
);

function ArticlesSection() {
  return (
    <Box
      sx={{
        width: '100%',
        py: { xs: 2, md: 4 },
        bgcolor: '#ffdd24',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <Typography
        fontWeight={600}
        sx={{ color: '#242424', fontSize: { xs: '1.5rem', md: '1.8rem' }, textAlign: 'center' }}
      >
        TOP ARTICLES
      </Typography>

      <ArticlesBox>
        {ArticlesData.map((article, index) => (
          <ArticleCard key={index} {...article} />
        ))}
      </ArticlesBox>

      <Box sx={{ mt: 2, mb: { xs: 5, md: 1 } }}>
        <Link to="/articles">
          <Button variant="contained" sx={{ bgcolor: '#242424', color: 'whitesmoke' }}>
            Browse More
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

export default ArticlesSection;
